module.exports = __webpack_public_path__ + "static/usecase_phone@3x-1b69b90c989cf4dc031ece7b2bc5ce42.png";